import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';
import { EditorState } from '../../slices/editor';

export const selectImagePropertyById = (id: string): any =>
    createSelector(
        (state: RootState) => state.editor,
        (state: EditorState) =>
            state.instanceTemplate?.values
                ?.filter((item) => item.path === 'content.src')
                .find((item) => item.id === id),
    );
